(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8992],{

/***/ 4252:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/get-started-biologics",
      function () {
        return __webpack_require__(34816);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 34816:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ Apps_GetStartedBiologics; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Paragraph/index.js + 1 modules
var Paragraph = __webpack_require__(74229);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/smart-react/PageMeta/index.js
var PageMeta = __webpack_require__(93890);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/smart-react/i18/index.js + 12 modules
var i18 = __webpack_require__(36971);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/shared-utils/fn/pipe.js
var pipe = __webpack_require__(75833);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/ProductsTab/index.js
var ProductsTab = __webpack_require__(7789);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Grid/index.js
var Grid = __webpack_require__(67478);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Section/index.js + 1 modules
var Section = __webpack_require__(93512);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Panel/index.js + 1 modules
var Panel = __webpack_require__(13398);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Heading/index.js + 1 modules
var Heading = __webpack_require__(42866);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/r1/atoms/ContentContainer/index.js
var ContentContainer = __webpack_require__(12985);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Badge/index.js + 1 modules
var Badge = __webpack_require__(20222);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Block/index.js + 1 modules
var Block = __webpack_require__(6949);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Button/index.js + 1 modules
var Button = __webpack_require__(18774);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/UList/index.js + 1 modules
var UList = __webpack_require__(51192);
// EXTERNAL MODULE: ./src/routes.js
var routes = __webpack_require__(30233);
// EXTERNAL MODULE: ./src/services/index.js + 11 modules
var services = __webpack_require__(69549);
// EXTERNAL MODULE: ./src/AppError/withErrorHandling.js
var withErrorHandling = __webpack_require__(71802);
// EXTERNAL MODULE: ./src/SiteLayout/index.js
var SiteLayout = __webpack_require__(26485);
// EXTERNAL MODULE: ./src/BiologicsHeader/index.js
var BiologicsHeader = __webpack_require__(79048);
;// CONCATENATED MODULE: ./src/Apps/GetStartedBiologics/index.js





















const iconPrime = "/images/geneious/logo/icon-prime.svg";
const iconBiologics = "/images/geneious/logo/icon-biologics.svg";
const GetStartedBiologics = ()=>{
    const [t] = (0,i18/* useLocale */.bU)("get-started-biologics");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SiteLayout/* default */.Z, {
        isWrapper: false,
        HeaderComponent: BiologicsHeader/* default */.Z,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(PageMeta/* default */.ZP, {
                title: t("META.TITLE"),
                description: t("META.DESCRIPTION"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PageMeta/* default.OGP */.ZP.OGP, {
                        locale: t("META.LOCALE"),
                        type: t("META.TYPE"),
                        title: t("META.TITLE"),
                        description: t("META.DESCRIPTION"),
                        url: t("META.URL"),
                        siteName: t("META.SITE_NAME"),
                        articlePublisher: t("META.ARTICLE_PUBLISHER")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PageMeta/* default.Canonical */.ZP.Canonical, {
                        href: t("META.CANONICAL")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PageMeta/* default.Twitter */.ZP.Twitter, {
                        card: t("META.TWITTER_CARD"),
                        title: t("META.TITLE"),
                        description: t("META.DESCRIPTION"),
                        site: t("META.TWITTER_SITE"),
                        creator: t("META.TWITTER_CREATOR")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* default */.Z, {
                utility: {
                    bgColor: "dotmatics-4"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Row */.X2, {
                    utility: {
                        bgColor: "white"
                    },
                    spacing: {
                        pt: 9
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Col */.JX, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Container */.W2, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* Row */.X2, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Col */.JX, {
                                        md: "auto",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductsTab/* default */.Z, {
                                            logoIcon: iconPrime,
                                            borderColor: "3",
                                            title: t("TAB1.TITLE"),
                                            description: t("TAB1.DESCRIPTION"),
                                            href: routes/* default.external.freeTrial */.Z.external.freeTrial
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Col */.JX, {
                                        md: "auto",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductsTab/* default */.Z, {
                                            logoIcon: iconBiologics,
                                            borderColor: "dotmatics-7",
                                            title: t("TAB2.TITLE"),
                                            description: t("TAB2.DESCRIPTION"),
                                            active: true
                                        })
                                    })
                                ]
                            })
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* default */.Z, {
                utility: {
                    bgColor: "dotmatics-4"
                },
                spacing: {
                    py: 20
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentContainer/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* Row */.X2, {
                        mx: true,
                        my: true,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Col */.JX, {
                                md: 6,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Panel/* default */.Z, {
                                    spacing: {
                                        py: 8,
                                        px: 10
                                    },
                                    className: "height-100 position--relative",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Badge/* default */.Z, {
                                            utility: {
                                                bgColor: "dotmatics-7",
                                                radius: 0
                                            },
                                            className: "position-absolute right-0 bottom-100p",
                                            children: t("COL1.BADGE")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                            Tag: "h2",
                                            size: "l",
                                            children: t("COL1.TITLE")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* default */.Z, {
                                            sx: {
                                                fontColor: "black--custom-1"
                                            },
                                            children: t("COL1.DESCRIPTION")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block/* default */.Z, {
                                            spacing: {
                                                my: 8
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default.Link */.Z.Link, {
                                                href: routes/* default.external.externalSignUp */.Z.external.externalSignUp,
                                                isBlock: true,
                                                type: "submit",
                                                children: t("COL1.BTN")
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block/* default */.Z, {
                                            spacing: {
                                                mb: 8
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* default */.Z, {
                                                    sx: {
                                                        fontWeight: "bold"
                                                    },
                                                    children: t("COL1.LIST_TITLE")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(UList/* default */.Z, {
                                                    type: "pros",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                            bulletColor: "dotmatics-7",
                                                            children: t("COL1.LIST_1")
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                            bulletColor: "dotmatics-7",
                                                            children: t("COL1.LIST_2")
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                            bulletColor: "dotmatics-7",
                                                            children: t("COL1.LIST_3")
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                            bulletColor: "dotmatics-7",
                                                            children: t("COL1.LIST_4")
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                            bulletColor: "dotmatics-7",
                                                            children: t("COL1.LIST_5")
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Col */.JX, {
                                md: 6,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Panel/* default */.Z, {
                                    spacing: {
                                        py: 8,
                                        px: 10
                                    },
                                    className: "height-100",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                            Tag: "h2",
                                            size: "l",
                                            children: t("COL2.TITLE")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* default */.Z, {
                                            sx: {
                                                fontColor: "black--custom-1"
                                            },
                                            children: t("COL2.DESCRIPTION")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block/* default */.Z, {
                                            spacing: {
                                                my: 8
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default.Link */.Z.Link, {
                                                href: routes/* default.external.requestDemo */.Z.external.requestDemo,
                                                isBlock: true,
                                                type: "submit",
                                                children: t("COL2.BTN")
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block/* default */.Z, {
                                            spacing: {
                                                mb: 8
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* default */.Z, {
                                                    sx: {
                                                        fontWeight: "bold"
                                                    },
                                                    children: t("COL2.LIST_TITLE")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(UList/* default */.Z, {
                                                    type: "pros",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                            bulletColor: "dotmatics-7",
                                                            children: t("COL2.LIST_1")
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                            bulletColor: "dotmatics-7",
                                                            children: t("COL2.LIST_2")
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                            bulletColor: "dotmatics-7",
                                                            children: t("COL2.LIST_3")
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                            bulletColor: "dotmatics-7",
                                                            children: t("COL2.LIST_4")
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                            bulletColor: "dotmatics-7",
                                                            children: t("COL2.LIST_5")
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var Apps_GetStartedBiologics = ((0,pipe/* default */.Z)(GetStartedBiologics, withErrorHandling/* default */.Z, services/* default */.Z));

;// CONCATENATED MODULE: ./pages/get-started-biologics/index.js



/***/ }),

/***/ 20222:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Badge_Badge; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/props/utility.js
var props_utility = __webpack_require__(18981);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/classes.js
var classes = __webpack_require__(67924);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Badge/Badge.js





const Badge = (param)=>{
    let { type =1 , Tag ="span" , status ="active" , utility ={
        ...props_utility/* utilityProps */.Gm
    } , className ="" , children  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Tag, {
        className: (0,classes/* classes */.S)("badge", "badge-v".concat(type), "badge-v".concat(type, "--").concat(status), ...(0,props_utility/* utilityClassName */.b2)(utility), className),
        children: children
    });
};
Badge.propTypes = {
    Tag: prop_types.string,
    type: (0,prop_types.oneOf)([
        1,
        2
    ]),
    utility: props_utility/* utilityPropTypes */.pQ,
    status: (0,prop_types.oneOf)([
        "active",
        "cancelled",
        "expired",
        "past-due",
        "pastdue",
        "early-access"
    ]),
    className: prop_types.string,
    children: prop_types.node.isRequired
};
/* harmony default export */ var Badge_Badge = (Badge);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Badge/index.js



/***/ }),

/***/ 13398:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Panel_Panel; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Block/index.js + 1 modules
var Block = __webpack_require__(6949);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/classes.js
var classes = __webpack_require__(67924);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Panel/Panel.js





const Panel = (param)=>{
    let { className ="" , shadow , ...props } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Block/* default */.Z, {
        className: (0,classes/* classes */.S)("panel", shadow && "panel--shadow", className),
        ...props
    });
};
Panel.propTypes = {
    shadow: prop_types.bool,
    ...Block/* default.propTypes */.Z.propTypes
};
/* harmony default export */ var Panel_Panel = (Panel);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Panel/index.js



/***/ }),

/***/ 7789:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _insightfulscience_atomic_react_Link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25522);
/* harmony import */ var _insightfulscience_atomic_react_Block__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6949);
/* harmony import */ var _insightfulscience_atomic_react_Heading__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(42866);
/* harmony import */ var _insightfulscience_atomic_react_Image__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(10334);
/* harmony import */ var _insightfulscience_atomic_react_Paragraph__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(74229);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _insightfulscience_atomic_react_props_sx__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(23720);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(67294);









const ProductsTab = (param)=>{
    let { borderColor , logoIcon , title , description , active , ...props } = param;
    const { href  } = props;
    const border = {
        top: {
            color: active ? borderColor : "white",
            width: "4"
        }
    };
    const CustomLink = (param)=>/*#__PURE__*/ {
        let { ...customProps } = param;
        return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Link__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
            ...customProps,
            isBaseClassName: false
        });
    };
    const Tag = href ? CustomLink : _insightfulscience_atomic_react_Block__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Tag, {
        ...props,
        sx: {
            fontColor: "black"
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_insightfulscience_atomic_react_Block__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            sx: {
                textAlign: "center"
            },
            utility: {
                bgColor: active ? "dotmatics-4" : "white",
                border
            },
            spacing: {
                pt: 4,
                pb: 5
            },
            ...props,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_insightfulscience_atomic_react_Heading__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    Tag: "h3",
                    size: "l",
                    center: true,
                    children: [
                        title,
                        " ",
                        logoIcon && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Image__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                            src: logoIcon,
                            spacing: {
                                ml: 1
                            }
                        })
                    ]
                }),
                description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Paragraph__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                    spacing: {
                        mb: 0
                    },
                    children: description
                })
            ]
        })
    });
};
ProductsTab.propTypes = {
    active: prop_types__WEBPACK_IMPORTED_MODULE_8__.bool,
    borderColor: _insightfulscience_atomic_react_props_sx__WEBPACK_IMPORTED_MODULE_6__/* .colorPropTypes */ .AK,
    logoIcon: prop_types__WEBPACK_IMPORTED_MODULE_8__.string,
    title: prop_types__WEBPACK_IMPORTED_MODULE_8__.string,
    description: prop_types__WEBPACK_IMPORTED_MODULE_8__.string,
    href: prop_types__WEBPACK_IMPORTED_MODULE_8__.string
};
/* harmony default export */ __webpack_exports__["Z"] = (ProductsTab);


/***/ }),

/***/ 87385:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ SimpleTemplate_SimpleTemplate; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Section/index.js + 1 modules
var Section = __webpack_require__(93512);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Grid/index.js
var Grid = __webpack_require__(67478);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Panel/index.js + 1 modules
var Panel = __webpack_require__(13398);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/classes.js
var classes = __webpack_require__(67924);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/color.js
var color = __webpack_require__(68657);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/props/sx.js
var props_sx = __webpack_require__(23720);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/props/utility.js
var props_utility = __webpack_require__(18981);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/SimpleTemplate/SimpleTemplate.js










const SimpleTemplate = (param)=>{
    let { cellWidth =8 , mdCellWidth =10 , paddingTop ="pt-9 pt-9--md" , paddingBottom ="pb-18 pb-18--md" , panel =true , panelPaddingY =16 , panelUtility ={
        ...props_utility/* utilityProps */.Gm
    } , children , bgColor =color/* bgColorBlack2 */.vk , className ="" , shadow =true , utility ={
        ...props_utility/* utilityProps */.Gm
    } , sx ={
        ...props_sx/* sxProps */.ET
    } , ...props } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* default */.Z, {
        className: (0,classes/* classes */.S)(paddingTop, paddingBottom, !(utility && utility.bgColor) && bgColor, ...(0,props_utility/* utilityClassName */.b2)(utility), ...(0,props_sx/* sxClassName */.ZA)(sx), className),
        ...props,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Container */.W2, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Row */.X2, {
                px: true,
                utility: {
                    justify: "center"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Col */.JX, {
                    md: mdCellWidth,
                    lg: cellWidth,
                    children: panel ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Panel/* default */.Z, {
                        shadow: shadow,
                        utility: panelUtility,
                        spacing: {
                            py: panelPaddingY
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Row */.X2, {
                            mx: true,
                            px: true,
                            utility: {
                                justify: "center"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Col */.JX, {
                                md: 10,
                                children: children
                            })
                        })
                    }) : children
                })
            })
        })
    });
};
SimpleTemplate.propTypes = {
    shadow: prop_types.bool,
    cellWidth: prop_types.number,
    mdCellWidth: prop_types.number,
    paddingTop: prop_types.string,
    paddingBottom: prop_types.string,
    panel: prop_types.bool,
    panelPaddingY: prop_types.number,
    panelUtility: props_utility/* utilityPropTypes */.pQ,
    children: prop_types.node.isRequired,
    bgColor: prop_types.string,
    utility: props_utility/* utilityPropTypes */.pQ,
    sx: props_sx/* sxPropTypes */.I1,
    className: prop_types.string
};
/* harmony default export */ var SimpleTemplate_SimpleTemplate = (SimpleTemplate);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/SimpleTemplate/index.js



/***/ }),

/***/ 66651:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14924);

class ApplicationError extends Error {
    toSerializable() {
        const { name , message , code , stack , originalError , tags  } = this;
        return {
            name,
            message,
            code,
            stack: typeof stack === "string" ? stack.split("\n") : stack,
            originalError: originalError ? {
                name: originalError.name,
                code: originalError.code,
                message: originalError.message
            } : null,
            tags
        };
    }
    toJSON() {
        return this.toSerializable();
    }
    constructor(originalError, code = 500, message = ApplicationError.defaultMessage[code], tags = null){
        super(message);
        (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(this, "name", "ApplicationError");
        this.code = code;
        this.originalError = originalError;
        this.stack = (originalError === null || originalError === void 0 ? void 0 : originalError.stack) || new Error().stack;
        this.tags = tags;
    }
}
(0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(ApplicationError, "defaultMessage", {
    400: "Bad Request",
    401: "Not Authorized",
    403: "Not Permitted",
    404: "Not Found",
    500: "Internal Error",
    503: "Service Unavailable"
});
(0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(ApplicationError, "of", (error)=>error instanceof ApplicationError ? error : new ApplicationError(error, error.code || 500, error.message));
(0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(ApplicationError, "BadRequest", ()=>new ApplicationError(null, 400));
(0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(ApplicationError, "NotAuthorized", ()=>new ApplicationError(null, 401));
(0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(ApplicationError, "NotFound", ()=>new ApplicationError(null, 404));
(0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(ApplicationError, "ServiceUnavailable", ()=>new ApplicationError(null, 503));
/* harmony default export */ __webpack_exports__["Z"] = (ApplicationError);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7959,8529,6436,9549,4096,9774,2888,179], function() { return __webpack_exec__(97239), __webpack_exec__(4252); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);